import React from "react";
import PropTypes from "prop-types";
import { formatEventDate } from "../../utility/DateUtils"
import EventModalRevised from "../EventModalRevised"
import GenerateEventReportModal from "../reports/GenerateEventReportModal"
import { isJaguar, isSuperadmin, isClient } from "../../utility/UserUtils"
import TemporaryItemFormModal from "../../items/temporary_items/TemporaryItemFormModal"
import EventAddressModal from "../modals/EventAddressModal"
class EventSubheader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      eventModalOpen: false
    }
  }
  


  renderActions() {
    const { event, user } = this.props;
    return (

      <div className="event-header-actions text-right">
        <EventModalRevised
          open={this.state.eventModalOpen}
          event={event}
          id={event.id}
          reload={true}
          renters={this.props.renters}
          shipping_addresses={this.props.shipping_addresses}
          onClose={()=>{
            //Reload page
            window.location.reload();
          }}
        />
        <a href={`/events/${event.slug}`} className={
          this.isSubheaderActive("overview") ? "active" : ""
        }>
          <span>Overview</span>
        </a>
        <a
        className={
          this.isSubheaderActive("manifest") ? "active" : ""
        }
        href={`/events/${event.slug}/manifest/shipping`}>
          <span>Manifest</span>
        </a>
        <a 
        className={
          this.isSubheaderActive("reports") ? "active" : ""
        }
        href={`/events/${event.id}/reports`}>
          <span>Reports</span>
        </a>

                {isJaguar(user) &&
          <>
            <a href="javascript:void(0);" onClick={()=>{
              this.setState({
                eventModalOpen: true
              })
            }}>
              Event Info
            </a>

          </>
        }
      </div>
    );
  }

  isSubheaderActive(tab) {
    const { activeTab } = this.props;
    return tab === activeTab;
  }

  static getBackgroundColor() {
    return "#486ca9"
  }

  render() {
    const { event } = this.props;
    return (
      <div className="event-subheader">
        <div className="event-subheader-inner-container container">

          <div className="event-subheader-title">
            <a className="event-subheader-header-link" href={`/events/${event.slug}`}><h1>{event.name}</h1></a>
            <div className="event-subheader-dates">
              {formatEventDate(event)}
            </div>
          </div>
          {this.renderActions()}
        </div>
      </div>
    );
  }
}

EventSubheader.propTypes = {
  event: PropTypes.object.optional,
};

export default EventSubheader;
